export const MIN_TERRAIN_EXAGGERATION = 1;
export const MAX_TERRAIN_EXAGGERATION = 3;
export const DEFAULT_TERRAIN_EXAGGERATION = 1.5;

/** Bounds display height without modifying recorded ride elevations. */
export function resolveTerrainExaggeration(value: number, fallback = DEFAULT_TERRAIN_EXAGGERATION): number {
  return Number.isFinite(value) && value >= MIN_TERRAIN_EXAGGERATION && value <= MAX_TERRAIN_EXAGGERATION
    ? value : fallback;
}
